import React from 'react'

const AllTimesheets = () => {
  const urlHost = window.location.origin

  return (
    <table className='m-4 text-left w-11/12'>
      <thead>
        <tr className='bg-regular-blue text-white w-full px-2 py-1'>
          <th colSpan='2' className='px-2 py-3 text-2xl'>All TimeSheet Data Connections</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className='font-semibold px-2 py-3 w-1/5'>JSON URL:</td>
          <td className='px-2 py-1'>{`${urlHost}/api/timesheets.json`}</td>
        </tr>
        <tr><td className='py-3'></td></tr>
      </tbody>
    </table>  )
}

export default AllTimesheets
